<script setup lang="ts" generic="TData">
import type { Table } from '@tanstack/vue-table'
import { computed } from 'vue'
import GatButton from '../gat-button/gat-button.vue'
import GatIcon from '../gat-icon/gat-icon.vue'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '../ui/dropdown-menu'
import { isGatColumnDef } from './index'
export interface DataTableViewOptionsProps<TData> {
  table: Table<TData>
  title?: string
}

const props = defineProps<DataTableViewOptionsProps<TData>>()

const columns = computed(() => {
  const cols = props.table
    .getAllColumns()
    .filter((column) => typeof column.accessorFn !== 'undefined' && column.getCanHide())

  return cols
})
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <GatButton variant="outline" size="sm" class="ml-auto hidden h-8 lg:flex">
        <gat-icon icon="Settings2" class="h-4 w-4" />
        {{ title ?? 'Columns' }}
      </GatButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" class="w-[150px]">
      <DropdownMenuLabel>Toggle columns</DropdownMenuLabel>
      <DropdownMenuSeparator />
      <template v-for="column in columns" :key="column.id">
        <DropdownMenuCheckboxItem
          class="capitalize"
          :model-value="column.getIsVisible()"
          @update:model-value="(value) => column.toggleVisibility(!!value)"
        >
          {{ isGatColumnDef(column.columnDef) ? column.columnDef.title : column.id }}
        </DropdownMenuCheckboxItem>
      </template>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
